import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import CheckIcon from '../../assets/svgs/CheckIcon';
import ChevronIcon from '../../assets/svgs/ChevronIcon';
import { useSelector } from 'react-redux';
import translate from '../../libs/i18n';

import { TypesSelectStyle } from '../DensityTypeSelect/TypesSelectStyle';

const DensityTypesSelect = ({
  types,
  selected,
  parent,
  placeholder,
  disabled,
  handleSelect,
}) => {
  const [show, setShow] = useState(false);
  const language = useSelector((state) => state.settings.language);

  useEffect(() => {
    if (selected) {
      setShow(false);
    }
  }, [parent?.id, selected]);

  return (
    <TypesSelectStyle
      className={types?.length && !disabled && show ? 'show' : null}
    >
      <button
        type="button"
        className="show-hide-list"
        disabled={disabled}
        onClick={() => setShow(!show)}
      >
        {!show &&
        selected &&
        selected?.name?.length ? (
          <div className="show-hide-selected">
            <div className="selected-name">
              {selected?.id === parent?.id ? 'Any' : translate((selected?.name).toLowerCase().replaceAll(' ', ''), language)}
            </div>
          </div>
        ) : (
          <div className="show-hide-unselected">
            {placeholder || 'Select Type'}
          </div>
        )}
        <span className="icon">
          <ChevronIcon />
        </span>
      </button>
      {types?.length ? (
        <div className="types-list-container">
          {types?.map((type) => {
            if (type?.id && type?.name?.length) {
              return (
                <button
                  key={type?.id}
                  className={`type-option${
                    selected?.id === type?.id ? ' selected' : ''
                  }`}
                  type="button"
                  onClick={() =>
                    handleSelect(selected?.id !== type?.id ? type : null)
                  }
                >
                  <div className="option-name">{translate((type?.name).toLowerCase().replaceAll(' ', ''), language)}</div>
                </button>
              );
            }

            return null;
          })}
        </div>
      ) : null}
    </TypesSelectStyle>
  );
};

DensityTypesSelect.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ),
  selected: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  parent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  handleSelect: PropTypes.func.isRequired,
};

DensityTypesSelect.defaultProps = {
  types: [],
  selected: null,
  parent: null,
  placeholder: '',
  disabled: false,
};

export default DensityTypesSelect;
